/**
 * Main application entry point
 * @module main
 */

import { debounce } from './js/utils';
import { commentsDrawerUtils } from './js/modules/comments';
import { initializeNavigation } from './js/modules/navigation';
import { handleScroll } from './js/modules/scroll';
import { initializePostLoading } from './js/modules/posts';
import { initializeForms } from './js/modules/forms';
import { generateListicleStructuredData } from './js/modules/structured-data';
import { initializePinterestSharing } from './js/modules/social';
import { processExternalLinks } from './js/modules/links';

// Initialize all functionality when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  // Mark page as loaded immediately since FlyingPress handles images
  document.body.classList.add('is-loaded');

  initializeNavigation();
  initializeForms();
  initializePostLoading();
  initializePinterestSharing();
  processExternalLinks();
  generateListicleStructuredData();
  commentsDrawerUtils();

});

// Handle scroll events with debouncing
window.addEventListener('scroll', debounce(handleScroll, 10));

// Handle window resize events with debouncing
window.addEventListener('resize', debounce(() => {
  // Add resize-specific logic here if needed
}, 250));
